<template>
  <svg :width="size" :height="size" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Ticket stub with torn edge -->
    <path d="M4 8h10v16H4V8z" :fill="color" opacity="0.85" />
    <!-- Torn edge -->
    <path d="M14 8l1 2-1 2 1 2-1 2 1 2-1 2 1 2-1 2h0" :stroke="color" stroke-width="1" fill="none" opacity="0.5" />
    <path d="M15 8h13v16H15l1-2-1-2 1-2-1-2 1-2-1-2 1-2-1-2z" :fill="color" />
    <!-- Star on ticket -->
    <path d="M22 14l1.5 3 3.5.5-2.5 2.5.5 3.5-3-1.5-3 1.5.5-3.5L17 17.5l3.5-.5L22 14z" fill="#0F0F14" opacity="0.7" />
    <!-- Stub text lines -->
    <line x1="6" y1="13" x2="12" y2="13" stroke="#0F0F14" stroke-width="1.5" stroke-linecap="round" opacity="0.5" />
    <line x1="6" y1="16" x2="11" y2="16" stroke="#0F0F14" stroke-width="1.5" stroke-linecap="round" opacity="0.5" />
    <line x1="6" y1="19" x2="10" y2="19" stroke="#0F0F14" stroke-width="1.5" stroke-linecap="round" opacity="0.5" />
  </svg>
</template>
<script setup lang="ts">
withDefaults(defineProps<{ size?: number; color?: string }>(), {
  size: 28,
  color: '#CC0000',
});
</script>
